import { render, staticRenderFns } from "./ForumQuickLinks.vue?vue&type=template&id=5a0a2b7c&scoped=true&"
import script from "./ForumQuickLinks.vue?vue&type=script&lang=js&"
export * from "./ForumQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./ForumQuickLinks.vue?vue&type=style&index=0&id=5a0a2b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a2b7c",
  null
  
)

export default component.exports